import {
  Rocket,
  Flame,
  Plane,
  PlaneTakeoff,
  Satellite,
  Orbit,
  Sprout,
} from "lucide-react"

export type Program = {
  label: string
  description: string
  category: string
  courses: string
  href: string
  icon: typeof Rocket
  color: string
  bg: string
}

export const programs: Program[] = [
  {
    label: "Modelismo Espacial",
    description: "Diseño y lanzamiento de cohetes para aprender STEM con retos por nivel.",
    category: "modelismo-coheteria",
    courses: "6 cursos",
    href: "/programs/modelismo-coheteria",
    icon: Rocket,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
  },
  {
    label: "Aeromodelismo",
    description: "Modelos RC para aprender estabilidad, control y diseño.",
    category: "aeromodelismo",
    courses: "2 cursos",
    href: "/programs/aeromodelismo",
    icon: PlaneTakeoff,
    color: "text-cyan-400",
    bg: "bg-cyan-400/10",
  },
  {
    label: "Aviación Y Aeronáutica",
    description: "Principios de vuelo, aeronaves y operación aeronáutica.",
    category: "aviacion-aeronautica",
    courses: "2 cursos",
    href: "/programs/aviacion-aeronautica",
    icon: Plane,
    color: "text-sky-400",
    bg: "bg-sky-400/10",
  },
  {
    label: "Exploración Espacial",
    description: "Misiones orbitales y exploración del cosmos con simulador espacial.",
    category: "exploracion-espacial",
    courses: "1 curso",
    href: "/programs/exploracion-espacial",
    icon: Orbit,
    color: "text-amber-400",
    bg: "bg-amber-400/10",
  },
  {
    label: "Programa Seminare",
    description: "Proyectos STEAM para investigación y experimentación.",
    category: "seminare",
    courses: "1 curso",
    href: "/programs/seminare",
    icon: Sprout,
    color: "text-lime-400",
    bg: "bg-lime-400/10",
  },
  {
    label: "Satélites",
    description: "Sistemas satelitales, órbitas y misión espacial.",
    category: "satelites",
    courses: "2 cursos",
    href: "/programs/satelites",
    icon: Satellite,
    color: "text-violet-400",
    bg: "bg-violet-400/10",
  },
  {
    label: "Programa Aves",
    description: "Itinerario formativo en ciencias aeroespaciales.",
    category: "aves",
    courses: "1 curso",
    href: "/programs/aves",
    icon: Flame,
    color: "text-orange-400",
    bg: "bg-orange-400/10",
  },
]

const programLabelByCategory: Record<string, string> = {
  ...Object.fromEntries(programs.map((p) => [p.category, p.label])),
  "modelismo-espacial": "Modelismo Espacial",
  coheteria: "Modelismo Espacial",
  propulsion: "Modelismo Espacial",
  aerodynamics: "Aviación Y Aeronáutica",
  space_systems: "Satélites",
  "simulador-espacial": "Exploración Espacial",
}

export function getProgramLabel(category?: string | null): string {
  if (!category) return ""
  return programLabelByCategory[category] ?? category
}
